import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Home } from 'tabler-icons-react';
import LogoNovaLight from '../../logos/LogoNovaLight.svg';
import '../../styles/notfound.css';

const isNova = process.env.REACT_APP_THEME === 'novaTheme' || !process.env.REACT_APP_THEME;

// Página 403: el usuario está autenticado pero su rol no tiene acceso a la vista.
// Reutiliza los estilos de notfound.css para mantener consistencia visual.
export default function SinAcceso() {
    const history = useHistory();

    return (
        <div className={`nf-page${isNova ? ' nf-page--nova' : ''}`}>
            <div className="nf-card">
                <svg className="nf-illus" viewBox="0 0 400 240" aria-hidden="true">
                    {/* Candado */}
                    <g transform="translate(200 96)">
                        {/* Arco */}
                        <path
                            d="M-34 4 v-20 a34 34 0 0 1 68 0 v20"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="9"
                            opacity="0.22"
                        />
                        {/* Cuerpo */}
                        <rect
                            x="-48"
                            y="4"
                            width="96"
                            height="74"
                            rx="12"
                            fill="#fff"
                            opacity="0.16"
                        />
                        {/* Ojo de la cerradura */}
                        <circle cx="0" cy="34" r="9" fill="var(--color-primary)" opacity="0.6" />
                        <rect
                            x="-4"
                            y="34"
                            width="8"
                            height="20"
                            rx="4"
                            fill="var(--color-primary)"
                            opacity="0.6"
                        />
                    </g>

                    {/* Banner industrial */}
                    <g transform="translate(118 170)">
                        <rect x="-8" y="6" width="10" height="16" rx="2" fill="#fff" opacity="0.2" />
                        <rect
                            x="162"
                            y="6"
                            width="10"
                            height="16"
                            rx="2"
                            fill="#fff"
                            opacity="0.2"
                        />
                        <rect width="164" height="44" rx="4" className="nf-banner-bg" />
                        <rect x="0" y="0" width="9" height="44" rx="2" className="nf-banner-stripe" />
                        <rect
                            x="155"
                            y="0"
                            width="9"
                            height="44"
                            rx="2"
                            className="nf-banner-stripe"
                        />
                        <text
                            x="82"
                            y="30"
                            textAnchor="middle"
                            fill="var(--color-primary)"
                            fontSize="17"
                            fontWeight="800"
                            fontFamily="WorkSans, sans-serif"
                            letterSpacing="0.1em"
                        >
                            ERROR 403
                        </text>
                    </g>
                </svg>

                <h1 className="nf-code">
                    4<span className="nf-accent">0</span>
                    <span className="nf-four-right">3</span>
                </h1>
                <h2 className="nf-title">Sin acceso</h2>
                <p className="nf-desc">
                    Tu rol no tiene permisos para ver esta sección. Si crees que deberías tener
                    acceso, contacta al administrador.
                </p>

                <div className="nf-actions">
                    <Button
                        variant="contained"
                        className="nf-btn-primary"
                        startIcon={<Home size={16} />}
                        onClick={() => history.push('/')}
                    >
                        Ir al panel principal
                    </Button>
                    <Button
                        variant="outlined"
                        className="nf-btn-ghost"
                        onClick={() => history.goBack()}
                    >
                        Volver
                    </Button>
                </div>

                <img src={LogoNovaLight} alt="NOVA" className="nf-logo" />
            </div>
        </div>
    );
}
